export default function MicromanagementVsControl() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Делегирование и микроменеджмент
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-4 max-w-3xl mx-auto leading-relaxed">
          Где заканчивается контроль и начинается микроменеджмент
        </p>

        <div className="grid sm:grid-cols-2 gap-6 mb-12 max-w-3xl mx-auto">
          <div className="bg-green-50 rounded-xl border border-green-200 p-5 md:p-6">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-full bg-green-200 flex items-center justify-center">
                <i className="ri-check-line text-green-700"></i>
              </div>
              <h3 className="font-bold text-green-800 text-base">Контроль</h3>
            </div>
            <p className="text-green-700 text-sm leading-relaxed">
              Заранее определённые точки проверки результата. Руководитель и сотрудник договорились, когда и что проверяется. Сотрудник знает, что от него ожидается, и работает самостоятельно между контрольными точками.
            </p>
          </div>
          <div className="bg-red-50 rounded-xl border border-red-200 p-5 md:p-6">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-full bg-red-200 flex items-center justify-center">
                <i className="ri-close-line text-red-700"></i>
              </div>
              <h3 className="font-bold text-red-800 text-base">Микроменеджмент</h3>
            </div>
            <p className="text-red-700 text-sm leading-relaxed">
              Постоянное вмешательство в процесс и контроль каждого шага сотрудника. Руководитель регулярно проверяет, что и как делает сотрудник, даёт указания по ходу работы и фактически выполняет задачу вместе с ним или за него.
            </p>
          </div>
        </div>

        <h3 className="text-xl font-bold text-gray-900 text-center mb-8">Как определить необходимый уровень контроля</h3>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-4xl mx-auto">
          {[
            { title: 'Сложность задачи', desc: 'Чем сложнее и важнее задача, тем чаще должны быть контрольные точки на начальном этапе.' },
            { title: 'Опыт сотрудника', desc: 'Новому сотруднику нужно больше контроля. Опытному — больше свободы и самостоятельности.' },
            { title: 'Уровень риска', desc: 'Если ошибка может привести к серьёзным последствиям, контроль должен быть чаще — особенно в начале.' },
            { title: 'Тип задачи', desc: 'Стандартные повторяющиеся задачи требуют меньше контроля, чем уникальные или творческие.' },
            { title: 'Мотивация сотрудника', desc: 'Высокомотивированный сотрудник требует меньше внешнего контроля — он сам заинтересован в результате.' },
            { title: 'Постепенное увеличение', desc: 'По мере роста компетенции сотрудника количество контрольных точек должно уменьшаться, а самостоятельность — расти.' },
          ].map((item) => (
            <div key={item.title} className="bg-gray-50 rounded-xl border border-gray-200 p-4 md:p-5">
              <h4 className="font-bold text-gray-900 text-sm mb-1.5">{item.title}</h4>
              <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}